import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SetupComponent } from './setup.component';

const routes: Routes = [
  {
    path: 'setup/:contaId',
    component: SetupComponent,
    data: { title: 'Setup' }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class SetupRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/setup/setup-routing.module.ts